import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table';
import { Box, Card, TextField, Typography, Toolbar } from '@material-ui/core';
import { localization } from '../../../config';

const TableStock = ({ data, onRowClick, filtreProduit }) => {
    const [filteredData, setFilteredData] = useState(data || []);
    const [filter, setFilter] = useState('');
    const [clickedOf, setClickedOf] = useState(null);

    // useEffect(() => {
    //     setFilteredData(
    //         data.filter((row) => filter === '' || row.of.includes(filter))
    //     );
    // }, [filter, data]);

    useEffect(() => {
        const filteredRows = data.filter((row) => filtreProduit && (row.idp === filtreProduit.idp && row.type_metal === filtreProduit.type_metal))
        setFilteredData(filteredRows);
        if (filteredRows.length === 1 && filteredRows[0]['client_reserve'] === null) {
            setClickedOf(filteredRows[0]?.of || null);
            onRowClick(filteredRows[0] || null);
        } else {
            setClickedOf(null);
            onRowClick(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filtreProduit, data]);

    const handleRowClick = (event, rowData) => {
        if (rowData.of === clickedOf) {
            setClickedOf(null);
            onRowClick(null);
        } else {
            onRowClick(rowData);
            setClickedOf(rowData.of);
        }
    };

    const smallCellStyle = { fontSize: 13, lineHeight: 1.25, padding: '6px 8px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
    const headerStyle = { fontSize: 12, fontWeight: 600, lineHeight: 1.15, padding: '6px 8px', whiteSpace: 'nowrap' };

    return (
    <Card className="scrollable-table" style={{ display:'flex', flexDirection:'column', height:'100%' }}>
            <Box display="flex" justifyContent="center" mb={1} mt={1} style={{padding:'0 4px'}}>
                <TextField
                    label="N° OF"
                    variant="outlined"
                    value={filter}
                    size='small'
                    onChange={(e) => setFilter(e.target.value)}
                    className="rounded-field"
                    style={{ width:90 }}
                />
            </Box>
            <MaterialTable
                columns={[
                    { title: 'OF', field: 'of', width: 90, type: 'numeric', cellStyle: smallCellStyle, headerStyle },
                    { title: 'Métal', field: 'metal', width: 70, cellStyle: smallCellStyle, headerStyle },
                    { title: 'Ref', field: 'ref', width: 60, type: 'numeric', align: 'center', cellStyle: smallCellStyle, headerStyle },
                    { title: 'Designation', field: 'designation', width: 150, cellStyle: smallCellStyle, headerStyle, render: r => <span style={{ display:'inline-block', maxWidth:150 }} title={r.designation}>{r.designation}</span> },
                    { title: 'Lieu', field: 'client', width: 120, cellStyle: smallCellStyle, headerStyle, render: r => <span style={{ display:'inline-block', maxWidth:120 }} title={r.client}>{r.client}</span> },
                    { title: 'Réservation', field: 'client_reserve', width: 150, cellStyle: smallCellStyle, headerStyle, render: r => r.client_reserve ? <span style={{ display:'inline-block', maxWidth:150 }} title={r.client_reserve}>{r.client_reserve}</span> : '' }
                ]}
                data={filteredData}
                onRowClick={handleRowClick}
                options={{
                    paging: false,
                    search: false,
                    padding: 'dense',
                    headerStyle,
                    rowStyle: rowData => ({
                        backgroundColor: rowData.of === clickedOf ? 'rgba(53,154,255,1)' : 'inherit',
                        fontSize:12,
                        lineHeight:'1.15'
                    })
                }}
                title=""
                components={{
                    Toolbar: () => (
                        <Toolbar style={{ minHeight:34 }}>
                            <div style={{ flex:1, textAlign:'center' }}>
                                <Typography variant="subtitle2" style={{ fontWeight:600 }}>Produit Identique en Stock</Typography>
                            </div>
                        </Toolbar>
                    )
                }}
                localization={localization}
                style={{ flex:1, display:'flex', flexDirection:'column' }}
            />
        </Card>
    );
};

export default TableStock;
